import deepmerge from "deepmerge";
import { stringifyDateRangeFilterArrayIndexForm, stringifyDateRangeFilterCommaDelimited } from "./apiQuery.utils";
import { isNil } from "./ramdaEquivalents.utils";
export function mapParamSetToString(params, defaultParams, options) {
    var allowInfinity = (options || {}).allowInfinity;
    if (allowInfinity !== false)
        allowInfinity = true;
    var paramsWithDefault = deepmerge(defaultParams || {}, params || {});
    return Object.entries(paramsWithDefault).map(function (entry) {
        var key = entry[0];
        var value = entry[1];
        switch (typeof value) {
            case 'boolean': {
                return value ? key : false;
            }
            case 'string':
            case 'number': {
                if (value === Infinity || value === -1) {
                    return key + "=" + 9999;
                }
                return key + "=" + encodeURIComponent(value);
            }
            case 'object': {
                if (value === null)
                    return key + "=";
                if (value instanceof Array) {
                    return value.filter(function (i) { return !isNil(i); }).map(function (v) { return encodeURIComponent(key) + "[]=" + encodeURIComponent(v); }).join('&');
                }
                if (key === 'objectFields') {
                    return Object.entries(value)
                        .filter(function (_a) {
                        var objName = _a[0], fieldsArray = _a[1];
                        return objName !== undefined && fieldsArray !== undefined;
                    })
                        .map(function (_a) {
                        var objName = _a[0], fieldsArray = _a[1];
                        return "fields[" + encodeURIComponent(objName) + "]=" + encodeURIComponent(fieldsArray.join(","));
                    }).join("&");
                }
                return Object.entries(value)
                    .filter(function (_a) {
                    var k = _a[0], v = _a[1];
                    return v !== undefined;
                })
                    .map(function (_a) {
                    var k = _a[0], v = _a[1];
                    if (k === 'whereEquals') {
                        return "filter[whereEquals][0]=" + v.key + "&filter[whereEquals][1]=" + v.values.join(',');
                    }
                    else if (k === 'dateRange') {
                        if (v.shouldFilterUseArrayIndexForm) {
                            return stringifyDateRangeFilterArrayIndexForm(k, v);
                        }
                        return encodeURIComponent(key) + "[" + encodeURIComponent(k) + "]=" + encodeURIComponent(stringifyDateRangeFilterCommaDelimited(v));
                    }
                    else
                        return encodeURIComponent(key) + "[" + encodeURIComponent(k) + "]=" + (v === null ? "" : encodeURIComponent(v));
                }).join('&');
            }
            default: {
                return undefined;
            }
        }
    }).filter(function (i) { return i; }).join('&') || undefined;
}
